export const profile = {
  profileFavoritesIconTitle: 'Favoritos',
  profileEditIconTitle: 'Editar',
  profileShareIconTitle: 'Compartilhar',
  profileAdditionalSectionTitle: 'Informações adicionais',
  profileFavoritesCurtainTitle: 'Favoritos',
  profileFavoriteActionTitle: 'Favoritar',
  profileFavoritedActionTitle: 'Favoritado',
  profileMessageAction: 'Mensagem',
  profileCurtainAdd: 'Adicionar',
  profileReportUser: 'Reportar usuário',
  profileReportTitle: 'Reportar',
  profileReportSuccess: 'Conteúdo reportado',
  profileReset: 'Redefinir',
  profileApply: 'Aplicar',
  profileCustomInvalidEmail: 'não é um endereço de e-mail válido',
  profileMaxContentSizeError: 'Você excedeu o tamanho máximo do conteúdo!',
  profileMaxAvatarSizeError: 'O tamanho do seu avatar é muito grande!',
  profileFavoritesCurtainSearchInputText: 'Pesquisar',
  profileTapShareCurtainOptionTitle: 'Copiar link',
  profileTapShareLinkCopiedAlertTitle: 'Link copiado!',
  profileQrShareCurtainTitle: 'Compartilhar perfil',
  profileQrShareCurtainShareButtonTitle: 'Compartilhar',
  profileQrShareCurtainCopyButtonTitle: 'Copiar link',
  profileQrShareCurtainCopiedAlertTitle: 'Link copiado!',
  profileQrTapShareProfileCurtainTitle: 'Compartilhe seu perfil',
  profileEditTitle: 'Editar',
  profileEditPersonalSectionTitle: 'Detalhes pessoais',
  profileEditContactsSectionTitle: 'Contatos',
  profileEditSocialSectionTitle: 'Redes sociais',
  profileEditAddSocialButtonTitle: 'Adicionar redes sociais',
  profileEditAdditionalSectionTitle: 'Informações adicionais',
  profileEditSaveButtonTitle: 'Salvar',
  profileEditSavedAlertTitle: 'Perfil salvo!',
  profileEditEmptyRequiredInputTitle: 'O valor não pode estar em branco',
  profileEditEmptyRequiredEmailInputTitle: 'O e-mail público não é válido',
  profileEditEmptyRequiredErrorTitle: 'Algo deu errado!',
  profileEditSocialsHint: 'Por favor, insira a URL do seu perfil social',
  preferences: 'Preferências',
  interestedIn: 'Interessado em',
  expertIn: 'Sou um especialista em',
  myPitch: 'Minha apresentação',
  qrBadge: 'Distintivo QR',
  touchpoints: 'Touchpoints',
  lookingFor: 'Estou procurando',
  topicsToDiscuss: 'Tópicos para discutir',
  createNew: 'Criar novo',
  viewTopic: 'Ver tópico',
  hobbyInterests: 'Hobbies e interesses',
  myNetwork: 'Minha rede',
  seeAll: 'Ver tudo',
  checkThemOut: 'Confira!',
  activities: 'Atividades',
  oneOnOne: 'Encontro 1:1',
  Leaderboard: 'Classificação',
  learnNetworking: 'Saiba mais sobre o Networking Hub',
  networkingGroup: 'Grupo de Networking',
  networkingLevel: 'Nível de Networking',
  addNote: 'Adicionar nota',
  notes: 'Notas',
  enterNote: 'Digite uma nota',
  shareUserProfile: 'Compartilhar perfil de usuário',
  flagUser: 'Reportar usuário'
}
